/*
 * ============
 * Open Door Page
 * ============
 *
 */

import mixin from "../../../mixins/mixin";
import rentalService from './../../../services/rental';

export default {
  data() {
    return {
      loading: false,
      returnMessage: "",
      action: "open",
      booking: {},
      rental: {},
      guest: {},
      isReturnMessage: false
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading : require('components/loading/loading.vue')
  },
  mixins:[mixin],
  async mounted() {
    let vm = this;

    if(vm.$route.params.hash && vm.$route.params.type) {
      vm.fetchBookingAndRentalByHash(vm.$route.params.hash);
    }
  },
  methods: {
    fetchBookingAndRentalByHash(hash) {
      let vm = this;
      vm.loading = true;
      rentalService.fetchBookingAndRental(vm, hash);
    },

    async openDoor() {
      let vm = this;
      vm.loading = true;
      let hash = vm.$route.params.hash;
      let type = vm.$route.params.type;
      rentalService.openOrCloseDoor(vm, vm.action, hash, type);
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/pages/rentals/open-door/open-door.js